import BaseSelectBox from 'components/atoms/base-select-box';
import { useGetCampaignQuestionKeys } from 'infrastructure/hooks/sms-campaigns/use-get-campaigns-question-keys';

import type { FC } from 'react';

interface QuestionKeySelectBoxProps {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const QuestionKeySelectBox: FC<QuestionKeySelectBoxProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { data, isLoading } = useGetCampaignQuestionKeys();

  return (
    <div>
      <BaseSelectBox
        options={data?.map((i) => ({ label: i, value: i })) ?? []}
        loading={isLoading}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};
export default QuestionKeySelectBox;
